module.exports = __webpack_public_path__ + "static/media/PDF_35.e108ab92.pdf";